import { SUPABASE_URL, getDbHeaders } from "./client";

// -- Typing indicator DB functions -------------------------------------------
export async function dbSetTyping(airline, toAirline, date) {
  const id = airline + "_" + toAirline;
  await fetch(SUPABASE_URL + "/rest/v1/typing", {
    method: "POST",
    headers: await getDbHeaders({ "Prefer": "resolution=merge-duplicates,return=minimal" }),
    body: JSON.stringify({ id, airline, to_airline: toAirline, date, updated_at: new Date().toISOString() }),
  });
}

export async function dbClearTyping(airline, toAirline) {
  const id = airline + "_" + toAirline;
  await fetch(SUPABASE_URL + "/rest/v1/typing?id=eq." + id, {
    method: "DELETE",
    headers: await getDbHeaders(),
  });
}

export async function dbGetTyping(toAirline, date) {
  // Get all rows where someone is typing TO this airline for today
  const res = await fetch(
    SUPABASE_URL + "/rest/v1/typing?to_airline=eq." + toAirline + "&date=eq." + date,
    { headers: await getDbHeaders() }
  );
  if (!res.ok) return [];
  return res.json();
}
